import { render, staticRenderFns } from "./newEncabezado.vue?vue&type=template&id=2034623c&scoped=true&"
import script from "./newEncabezado.vue?vue&type=script&lang=js&"
export * from "./newEncabezado.vue?vue&type=script&lang=js&"
import style0 from "./newEncabezado.vue?vue&type=style&index=0&id=2034623c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2034623c",
  null
  
)

export default component.exports